import type { StateAbbreviation } from "@nimble/data-service-client/types";
import type { DistrictNcesId } from "@nimble/datamodel/types/ncesId";
import { NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import { getSchoolAutocomplete } from "@/lib/api-clients/candidate-api-client";

export default function useSchoolsAutocomplete(
  schools: string[] | null,
  search: string | null,
  states: StateAbbreviation[],
  districts: DistrictNcesId[],
) {
  return useQuery({
    queryKey: [`schools-autocomplete`, search, schools, states, districts],
    queryFn: () =>
      getSchoolAutocomplete(NEXT_JS_SERVER_COMPONENT_DEFAULT_CACHING_STRATEGY)(
        schools,
        search,
        states,
        districts,
      ),
  });
}
